/* THE GOAT — storefront behaviour: cart drawer, bundle builder, tilt, reveals, wheel. */
(function () {
  const money = (cents) =>
    (window.GOAT?.money_format || "${{amount}}").replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));

  /* ---------- scroll reveals ---------- */
  const io = "IntersectionObserver" in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.setAttribute("data-visible", "true");
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" })
    : null;
  const flag = (name, fallback = true) => {
    const v = document.body?.dataset?.[name];
    return v === undefined ? fallback : v !== "false";
  };

  const bindReveals = (root = document) => {
    if (!flag("enableReveals")) {
      root.querySelectorAll(".reveal").forEach((el) => el.setAttribute("data-visible", "true"));
      return;
    }
    root.querySelectorAll(".reveal:not([data-visible])").forEach((el, i) => {
      el.style.transitionDelay = `${(Number(el.dataset.delay) || i * 60)}ms`;
      if (io) io.observe(el); else el.setAttribute("data-visible", "true");
    });
  };

  /* ---------- hover tilt on cards ---------- */
  const bindTilt = (root = document) => {
    if (!flag("enableTilt")) return;
    if (window.matchMedia("(hover: none), (max-width: 860px)").matches) return;
    root.querySelectorAll("[data-tilt]").forEach((el) => {
      if (el.dataset.tiltBound) return;
      el.dataset.tiltBound = "1";

      const glare = el.querySelector(".card__glare");
      el.addEventListener("pointermove", (e) => {
        const r = el.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width;
        const py = (e.clientY - r.top) / r.height;
        el.style.transform = `perspective(1000px) rotateY(${(px - 0.5) * 9}deg) rotateX(${(0.5 - py) * 9}deg) translateY(-4px)`;
        if (glare) glare.style.background = `radial-gradient(closest-side at ${px * 100}% ${py * 100}%, rgba(255,255,255,.5), transparent)`;
      });
      el.addEventListener("pointerleave", () => { el.style.transform = ""; });
    });
  };


  /* ---------- cart ---------- */
  const drawer = () => document.querySelector("[data-cart-drawer]");
  const openDrawer = () => { drawer()?.setAttribute("aria-hidden", "false"); renderCart(); };
  const closeDrawer = () => drawer()?.setAttribute("aria-hidden", "true");
  const mobileMenu = () => document.querySelector("[data-mobile-menu]");
  const openMenu = () => mobileMenu()?.setAttribute("aria-hidden", "false");
  const closeMenu = () => mobileMenu()?.setAttribute("aria-hidden", "true");

  async function renderCart() {
    const d = drawer();
    if (!d) return;
    const items = d.querySelector("[data-cart-items]");
    let cart;
    try {
      const base = (window.GOAT && window.GOAT.routes && window.GOAT.routes.cart_url) || "/cart";
      const res = await fetch(`${base}.js`, { headers: { Accept: "application/json" } });
      cart = await res.json();
    } catch (err) {
      console.warn("[goat] cart fetch failed", err);
      return;
    }
    if (!cart || !Array.isArray(cart.items)) return;

    const count = document.querySelector("[data-cart-count]");
    const total = d.querySelector("[data-cart-total]");
    const threshold = (Number(d.dataset.freeShipping) || 80) * 100;

    if (count) {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    }
    if (total) total.textContent = money(cart.total_price);

    if (items) {
      items.innerHTML = cart.items.length
        ? cart.items
            .map((i) => {
              const img = i.image
                ? i.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2")
                : (i.featured_image && i.featured_image.url) || "";
              const variant = i.variant_title && i.variant_title !== "Default Title" ? i.variant_title : "";
              return `
        <div class="line">
          ${img ? `<img src="${img}" alt="" width="64" height="80" loading="lazy">` : `<span class="line__ph"></span>`}
          <div>
            <a href="${i.url}"><strong>${i.product_title || i.title}</strong></a>
            <p class="card__sub">${variant}</p>
            <div class="line__qty">
              <button type="button" data-qty="${i.key}" data-to="${i.quantity - 1}" aria-label="Remove one">&minus;</button>
              <span>${i.quantity}</span>
              <button type="button" data-qty="${i.key}" data-to="${i.quantity + 1}" aria-label="Add one">+</button>
            </div>
          </div>
          <span class="price">${money(i.final_line_price)}</span>
        </div>`;
            })
            .join("")
        : `<p class="card__sub">${items.dataset.empty || "Nothing in the crate yet."}</p>`;
    }

    const bar = d.querySelector("[data-ship-bar]");
    const copy = d.querySelector("[data-ship-copy]");
    if (bar && threshold) {
      const pct = Math.min(100, (cart.total_price / threshold) * 100);
      const fill = bar.querySelector("b");
      if (fill) fill.style.width = `${pct}%`;
      const unlocked = d.dataset.shipUnlocked || "Free shipping unlocked";
      const progress = d.dataset.shipProgress || "{amount} away from free shipping";
      if (copy) {
        copy.textContent =
          cart.total_price >= threshold
            ? unlocked
            : progress.replace("{amount}", money(threshold - cart.total_price));
      }
    }
  }



  const R = () => (window.GOAT && window.GOAT.routes) || {};

  async function addToCart(items) {
    const clean = (items || []).filter((i) => i && Number(i.id) > 0);
    if (!clean.length) {
      alert("This item is unavailable right now.");
      return false;
    }

    const addUrl = R().cart_add_url || "/cart/add";
    const post = (body, headers) =>
      fetch(`${addUrl}.js`, { method: "POST", headers, body, credentials: "same-origin" });

    let res;
    try {
      res = await post(JSON.stringify({ items: clean }), {
        "Content-Type": "application/json",
        Accept: "application/json",
      });
    } catch (err) {
      console.warn("[goat] add failed", err);
    }

    // Some setups reject the JSON body (proxies, older cart API) — retry as form data.
    if (!res || !res.ok) {
      const fd = new FormData();
      clean.forEach((i, n) => {
        fd.append(`items[${n}][id]`, i.id);
        fd.append(`items[${n}][quantity]`, i.quantity || 1);
      });
      try {
        res = await post(fd, { Accept: "application/json" });
      } catch (err) {
        console.warn("[goat] form add failed", err);
      }
    }

    if (!res || !res.ok) {
      let msg = "Could not add to crate.";
      try {
        const j = await res.json();
        if (j && (j.description || j.message)) msg = j.description || j.message;
      } catch (_) {}
      alert(msg);
      return false;
    }

    await renderCart();
    openDrawer();
    return true;
  }



  async function changeQty(key, quantity) {
    await fetch(`${R().cart_change_url || "/cart/change"}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
    });
    renderCart();
  }

  /* ---------- bundle builder ---------- */
  function bindBuilder(root) {
    let size = Number(root.dataset.size || 3);
    let discount = 10;
    const quantities = new Map();
    const choices = Array.from(root.querySelectorAll("[data-choice]"));
    const slotsRoot = root.querySelector("[data-slots]");
    const cta = root.querySelector("[data-builder-add]");

    const paint = () => {
      const picked = choices.flatMap((choice) => Array.from({ length: quantities.get(choice.dataset.id) || 0 }, () => choice));
      slotsRoot.innerHTML = Array.from({ length: size }, (_, index) => picked[index]
        ? `<div class="builder__slot is-filled"><img src="${picked[index].dataset.img}" alt=""></div>`
        : `<div class="builder__slot"><span>+</span></div>`).join("");
      choices.forEach((choice) => {
        choice.querySelector("[data-qty]").textContent = quantities.get(choice.dataset.id) || 0;
        choice.querySelector('[data-step="-1"]').disabled = !quantities.get(choice.dataset.id);
        choice.querySelector('[data-step="1"]').disabled = picked.length >= size;
      });
      const remaining = size - picked.length;
      const rrp = picked.reduce((sum, choice) => sum + Number(choice.dataset.price || 0), 0);
      const total = Math.round(rrp * (1 - discount / 100));
      root.querySelector("[data-builder-status]").textContent = remaining ? `${remaining} slot${remaining === 1 ? "" : "s"} to fill` : "Box complete";
      root.querySelector("[data-builder-ready]").hidden = remaining !== 0;
      root.querySelector("[data-builder-price]").textContent = money(total);
      const rrpEl = root.querySelector("[data-builder-rrp]");
      rrpEl.textContent = money(rrp);
      rrpEl.hidden = !rrp || total === rrp;
      cta.disabled = remaining !== 0;
      cta.textContent = remaining ? `Pick ${remaining} more` : `${cta.dataset.ready} ${size}-pack`;
    };

    root.querySelectorAll("[data-pack-size]").forEach((button) => button.addEventListener("click", () => {
      size = Number(button.dataset.packSize);
      discount = Number(button.dataset.discount || 0);
      quantities.clear();
      root.querySelectorAll("[data-pack-size]").forEach((item) => item.classList.toggle("is-active", item === button));
      paint();
    }));

    choices.forEach((choice) => choice.querySelectorAll("[data-step]").forEach((button) =>
      button.addEventListener("click", () => {
        const id = choice.dataset.id;
        const current = quantities.get(id) || 0;
        const total = Array.from(quantities.values()).reduce((sum, value) => sum + value, 0);
        const next = Math.max(0, current + Number(button.dataset.step));
        if (next > current && total >= size) return;
        if (next) quantities.set(id, next); else quantities.delete(id);
        paint();
      })));

    cta.addEventListener("click", () => {
      addToCart(Array.from(quantities.entries()).map(([id, quantity]) => ({ id: Number(id), quantity })));
    });

    paint();
  }

  function bindBundleCarousel(root = document) {
    root.querySelectorAll("[data-bundle-track]").forEach((track) => {
      const section = track.closest("section");
      const move = (direction) => track.scrollBy({ left: direction * Math.min(track.clientWidth * 0.8, 440), behavior: "smooth" });
      section?.querySelector("[data-bundle-prev]")?.addEventListener("click", () => move(-1));
      section?.querySelector("[data-bundle-next]")?.addEventListener("click", () => move(1));
    });
  }

  /* ---------- spin wheel ---------- */
  function bindWheel(el) {
    const close = () => el.setAttribute("aria-hidden", "true");
    el.querySelectorAll("[data-wheel-close]").forEach((b) =>
      b.addEventListener("click", () => {
        try { localStorage.setItem("goat-wheel", "closed"); } catch (e) {}
        close();
      }),
    );
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && el.getAttribute("aria-hidden") === "false") close();
    });

    let stored = null;
    try { stored = localStorage.getItem("goat-wheel"); } catch (e) {}
    if (stored) return;

    const disc = el.querySelector("[data-wheel-disc]");
    const result = el.querySelector("[data-wheel-result]");
    const form = el.querySelector("[data-wheel-form]");
    let prizes = [];
    try { prizes = JSON.parse(el.dataset.prizes || "[]"); } catch (e) {}
    if (!prizes.length) prizes = [{ label: "10% OFF", code: "GOAT10" }];

    const delay = Number(el.dataset.delay || 8000);
    setTimeout(() => el.setAttribute("aria-hidden", "false"), isNaN(delay) ? 8000 : delay);

    let spun = false;
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      if (spun) return;
      spun = true;
      const index = Math.floor(Math.random() * prizes.length);
      const win = prizes[index];
      const segment = 360 / prizes.length;
      const angle = 1440 + (360 - index * segment - segment / 2);
      if (disc) disc.style.transform = "rotate(" + angle + "deg)";
      form.querySelector("[data-wheel-spin]").disabled = true;
      form.querySelector("[data-wheel-spin]").textContent = "Spinning…";
      setTimeout(() => {
        form.hidden = true;
        result.hidden = false;
        result.innerHTML =
          '<strong class="display-md">' + win.label + "</strong><br>" +
          '<span class="wheel__copy">Code <b>' + win.code + "</b> is locked to your cart for the next 30 minutes.</span>";
        try {
          localStorage.setItem("goat-wheel", win.code);
          localStorage.setItem("goat-discount", JSON.stringify(win));
        } catch (err) {}
      }, 4200);
    });
  }


  /* ---------- boot ---------- */
  document.addEventListener("DOMContentLoaded", () => {
    bindReveals();
    bindTilt();
    renderCart();
    document.querySelectorAll("[data-builder]").forEach(bindBuilder);
    bindBundleCarousel();
    const w = document.querySelector("[data-wheel]");
    if (w && !w.dataset.bound) bindWheel(w);

  });

  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-cart-open],[data-cart-close],[data-menu-open],[data-menu-close],[data-qty],[data-add]");
    if (!t) return;
    if (t.matches("[data-cart-open]")) { e.preventDefault(); openDrawer(); }
    if (t.matches("[data-cart-close]")) closeDrawer();
    if (t.matches("[data-menu-open]")) openMenu();
    if (t.matches("[data-menu-close]")) closeMenu();
    if (t.matches("[data-qty]")) changeQty(t.dataset.qty, Number(t.dataset.to));
    if (t.matches("[data-add]")) {
      e.preventDefault();
      addToCart([{ id: Number(t.dataset.add), quantity: Number(t.dataset.quantity || 1) }]);
    }
  });

  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { closeDrawer(); closeMenu(); } });

  // Theme editor re-renders sections without a page load.
  document.addEventListener("shopify:section:load", (e) => {
    bindReveals(e.target);
    bindTilt(e.target);
    e.target.querySelectorAll("[data-builder]").forEach(bindBuilder);
    bindBundleCarousel(e.target);
  });

  window.GoatCart = { add: addToCart, refresh: renderCart, open: openDrawer };
})();
